// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2KBhK","rotate":"_2o0Gr","dash":"_20rmu","color":"_3weUy"};